import axios from "axios";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Icon,
  InputNumber,
  Radio,
  Row,
  Select,
  Spin,
  Tooltip,
} from "antd";

import RadioButton from "antd/lib/radio/radioButton";
import AddPatientModal from "../Users/AddPatientModal";

import {
  ADD_PATIENT_DETAILS,
  EDIT_EPRESCRIPTION,
  MENU_CHANGE,
} from "../../ActionTypes/ActionTypes";
import DoneStatusModal from "./DoneStatusModal";

const FormItem = Form.Item;
const { Option } = Select;
const RadioGroup = Radio.Group;

let timeout;
let currentValue;

function fetch(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    axios({
      method: "get",
      url: `/doctors/lookup_doctors.json?name=${value}`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((d) => {
      let matchedList;
      if (currentValue === value) {
        matchedList = d.data;
      }
      callback(matchedList);
    });
  }

  timeout = setTimeout(fake, 300);
}

class NormalLoginForm extends React.Component {
  state = {
    loading: false,
    fetching: false,
    dataForModal: {},
    visiblePatientModal: false,
    docConfirmLoad: false,
    patientSubmitLoading: false,
    submitLoading: false,
    visibleDocModal: false,
    data: [],
    value: "",
    partnersList: [],
    partnerLocations: [],
    doctorsList: [],
    user_id: "",
    partner_id: "",
    status: 0,
    doneStatusModal: false,
    // doc status
    docSearchValue: "",
    doctor_id: "",
    docFetching: false,
    docList: [],
    dummy: [],
  };

  /* eslint-disable func-names */
  typewatch = (function () {
    let timer = 0;
    return function (callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })();

  componentDidMount = () => {
    this.loadPartners();
  };

  loadPartners = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/partners.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        // console.log(response.data);
        this.setState({ partnersList: response.data }, () => {
          this.setState({ loading: false });
        });
      })
      .catch((error) => {
        alert(
          `Internet Not working, Please check you connection: ${error.code}`
        );
      });
  };

  loadDoctors = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/doctors.json",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    })
      .then((response) => {
        console.log(response.data);
        this.setState({ doctorsList: response.data }, () => {
          this.setState({ loading: false });
        });
      })
      .catch((error) => {
        alert(
          `Internet Not working, Please check you connection: ${error.code}`
        );
      });
  };

  saveFormRef = (formRef) => {
    this.formRef = formRef;
  };

  saveFormRefPatient = (formRef) => {
    this.formRefPatient = formRef;
  };

  showModal = () => {
    this.setState({ visiblePatientModal: true });
  };

  handleCancel = () => {
    this.setState({ visiblePatientModal: false });
  };

  handleCreate = () => {
    const { form } = this.formRefPatient.props;
    // console.log(this.state.value, this.state.user_id);
    form.validateFields((err, values) => {
      if (err) {
        console.log(err);
        return;
      }
      if (values.dob !== undefined || values.dob !== "") {
        values.dob = moment(values.dob).format("YYYY-MM-DD");
      } else {
        values.dob = "";
      }

      if (values.last_name === undefined) {
        values.last_name = "";
      }

      // console.log(values, 'Submitted');
      values.user_type = "patient";

      values.address = {
        line_1: values.line_1,
        line_2: values.line_2,
        city: values.city,
        state: values.state,
        pin_code: values.pin_code,
        country: values.country,
      };

      delete values.line_1;
      delete values.line_2;
      delete values.city;
      delete values.state;
      delete values.pin_code;
      delete values.country;

      // console.log(JSON.stringify(values));
      this.setState({ patientSubmitLoading: true });
      axios({
        method: "post",
        url: "/users/create_patient",
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: { user: values },
      }).then((response) => {
        // console.log(response.data);
        const formField = this.props.form; // eslint-disable-line react/destructuring-assignment
        formField.setFieldsValue({ name: response.data.first_name });
        this.setState({
          value: `${response.data.first_name + response.data.last_name}`,
          user_id: response.data.id,
          visiblePatientModal: false,
          patientSubmitLoading: false,
        });
      });

      // form.resetFields();
    });
  };

  showDocModal = () => {
    this.setState({ visibleDocModal: true });
  };

  handleDocCancel = () => {
    this.setState({ visibleDocModal: false });
  };

  handleDocCreate = () => {
    const { form } = this.formRef.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      // console.log(values);
      this.setState({ docConfirmLoad: true });
      axios({
        method: "post",
        url: "/doctors.json",
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
        data: { doctor: values },
      }).then((response) => {
        console.log(response.data);
        this.setState({ docConfirmLoad: false });
        this.loadDoctors();
      });

      form.resetFields();
      this.setState({ visibleDocModal: false });
    });
  };

  handleChange = (name) => {
    const { value } = this.state;
    this.setState({ value });

    if (value.length === 0) {
      this.setState({ data: [] });
    }

    this.typewatch(() => {
      this.setState({ fetching: true });
      axios({
        method: "get",
        url: `users/lookup_patients?first_name=${name}`,
        headers: { Authorization: sessionStorage.getItem("jwtToken") },
      }).then((response) => {
        // console.log(JSON.stringify(response.data));
        this.setState({
          data: response.data,
          fetching: false,
        });
      });
    }, 300);
  };

  handleSelectName = (id, option) => {
    const { data } = this.state;
    const user_id = option.props.id;
    this.setState({ user_id });
    const last_data = data.filter((dat) => dat.id === user_id);

    // if there is no last order then just skip setting partner_id
    if (last_data[0].last_order === null) {
      this.setState({ partner_id: false });
      return;
    }

    this.setState({ partner_id: last_data[0].last_order.partner_id });
    this.handlePartnerChange(last_data[0].last_order.partner_id);
  };

  handleBlurName = () => {
    const { user_id } = this.state;
    const { form } = this.props;
    if (user_id === "") {
      form.setFields({
        name: {
          value: "",
          errors: [new Error("Patient Does not exist please create")],
        },
      });
    }
  };

  handlePartnerChange = (value) => {
    const { partnersList } = this.state;
    this.setState({
      partner_id: value,
    });

    const newpartners = partnersList.filter(
      (partner) => partner.id === Number(value)
    );

    this.setState({
      partnerLocations: newpartners[0].partner_locations,
    });
  };

  onReminderChange = (event) => {
    this.setState({ reminder: event.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { form, setOrderValuesInStore } = this.props;
    const { user_id, doctor_id } = this.state;

    form.validateFields((err, values) => {
      if (!err) {
        values.end_date = "";
        values.start_date = moment(values.start_date).format("YYYY-MM-DD");
        values.user_id = user_id;

        // delete values['month'];
        delete values.name;
        delete values.month;
        delete values.doctor_id;

        this.setState({ submitLoading: true });
        axios({
          method: "post",
          url: `/orders.json?doctor_id=${doctor_id}`,
          headers: { Authorization: sessionStorage.getItem("jwtToken") },
          data: { order: values },
        }).then((response) => {
          // console.log(response.data);
          setOrderValuesInStore({
            order_id: response.data.id,
            user_id: values.user_id,
            start_date: values.start_date,
            end_date: values.end_date,
            p_prescriptions_url: [],
          });
          this.setState({
            status: 1,
            doneStatusModal: true,
            submitLoading: false,
          });
          form.resetFields();
        });
      }
    });
  };

  goToAllOrders = () => {
    const { history, changeMenu } = this.props;
    this.setState({ doneStatusModal: false });
    history.push("/allOrders");
    changeMenu("/allOrders");
  };

  goToEPrescription = () => {
    const { history, setEPrescriptionMedicine } = this.props;
    setEPrescriptionMedicine([], "");
    this.setState({ doneStatusModal: false });
    history.push("/addMedOrder");
  };

  handleDocSearch = (value) => {
    // console.log(value);
    this.setState({ docFetching: true });
    if (value.length > 2) {
      fetch(value, (docList) =>
        this.setState({
          docList,
          docFetching: false,
        })
      );
    }
  };

  handleDocChange = (value) => {
    this.setState({
      docSearchValue: value,
    });
  };

  handleDocSelect = (value) => {
    console.log(value);
    this.setState({ doctor_id: value });
  };

  render() {
    const { form } = this.props;
    const {
      data,
      partnersList,
      partnerLocations,
      value,
      fetching,
      patientSubmitLoading,
      dataForModal,
      visiblePatientModal,
      partner_id,
      submitLoading,
      doneStatusModal,
      docList,
      dummy,
      docSearchValue,
      docFetching,
    } = this.state;

    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    };
    const doubleformItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
    };
    const thirdformItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5, pull: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, pull: 6 },
      },
    };

    const terms = ["Short Term", "Long Term", "Potential Long Term"];
    const language = ["English", "Hindi"];

    const options = data.map((d) => (
      <Option key={`${d.first_name} ${d.last_name}`} id={d.id}>
        {d.first_name} {d.last_name} –– {d.mobile_number}
      </Option>
    ));

    const optns = partnersList.map((partner) => (
      <Option key={`${partner.id}`}>{partner.name}</Option>
    ));

    const termOptions = terms.map((term) => (
      <Option key={term} value={term}>
        {term}
      </Option>
    ));

    const locationOptns = partnerLocations.map((location) => (
      <Option key={`${location.id}`}>{location.name}</Option>
    ));

    const languageOptns = language.map((location) => (
      <Option key={`${location}`}>{location}</Option>
    ));

    // doc related function
    const docOptions =
      docList === undefined
        ? dummy.map((d) => <Option key={d.id}>{d.name}</Option>)
        : docList.map((d) => <Option key={d.id}>{d.name}</Option>);

    return (
      <div style={{ textAlign: "center", width: "90%", margin: "auto" }}>
        <Form onSubmit={this.handleSubmit}>
          <Row type="flex" justify="center">
            <Col span={12}>
              <FormItem {...doubleformItemLayout} label="Start Date">
                {getFieldDecorator("start_date", {
                  rules: [
                    { required: true, message: "Please select a start date!" },
                  ],
                })(<DatePicker style={{ width: "100%" }} />)}
              </FormItem>
            </Col>

            <Col span={12}>
              <FormItem {...thirdformItemLayout} label="Language">
                {getFieldDecorator("order_language", {
                  rules: [{ required: true, message: "Label Language?" }],
                  initialValue: "English",
                })(
                  <Select
                    showSearch
                    style={{ width: "83%" }}
                    placeholder="Order Language?"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {languageOptns}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <FormItem {...formItemLayout} label="Start typing Name">
            {getFieldDecorator("name", {
              rules: [{ required: true, message: "Name is required!" }],
            })(
              <Select
                mode="combobox"
                value={value}
                notFoundContent={fetching ? <Spin size="small" /> : "Not Found"}
                onChange={this.handleChange}
                onSelect={(id, option) => this.handleSelectName(id, option)}
                /* eslint-disable no-shadow */
                onBlur={(id, options) => this.handleBlurName(id, options)}
              >
                {options}
              </Select>
            )}
            or
            <div>
              <Button
                type="primary"
                loading={patientSubmitLoading}
                onClick={this.showModal}
              >
                Add Patient
              </Button>
              {visiblePatientModal ? (
                <AddPatientModal
                  wrappedComponentRef={this.saveFormRefPatient}
                  data={dataForModal}
                  visible={visiblePatientModal}
                  onCancel={this.handleCancel}
                  onCreate={this.handleCreate}
                  confirmLoading={patientSubmitLoading}
                />
              ) : (
                ""
              )}
            </div>
          </FormItem>

          <Row type="flex" justify="center">
            <Col span={12}>
              <FormItem {...doubleformItemLayout} label="Partner">
                {getFieldDecorator("partner_id", {
                  rules: [{ required: true, message: "Name is required!" }],
                  initialValue: partner_id
                    ? String(partner_id)
                    : "Select a partner",
                })(
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    onChange={this.handlePartnerChange}
                    onSelect={this.handlePartnerChange}
                    placeholder="Select a partner"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {optns}
                  </Select>
                )}
              </FormItem>
            </Col>

            <Col span={12}>
              <FormItem {...thirdformItemLayout} label="Default cycle">
                {getFieldDecorator("refill_cycle", {
                  rules: [{ required: true, message: "Default cycle length!" }],
                })(<InputNumber min={1} style={{ width: "83%" }} />)}
              </FormItem>
            </Col>

            <Col span={12}>
              <FormItem {...doubleformItemLayout} label="Location">
                {getFieldDecorator("partner_location_id", {
                  rules: [{ required: true, message: "Location is required!" }],
                })(
                  <Select
                    showSearch
                    placeholder="Select a partner location"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {locationOptns}
                  </Select>
                )}
              </FormItem>
            </Col>

            <Col span={12}>
              <FormItem
                {...thirdformItemLayout}
                label={
                  <span>
                    <Tooltip title="How long duration of this order is going to be?">
                      Type
                      <Icon type="question-circle-o" />
                    </Tooltip>
                  </span>
                }
              >
                {getFieldDecorator("order_type", {
                  rules: [{ required: false, message: "Type is required!" }],
                })(
                  <Select
                    showSearch
                    style={{ width: "83%" }}
                    placeholder="Please select term"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {termOptions}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row type="flex" justify="center">
            <Col span={12}>
              <FormItem {...doubleformItemLayout} label="Need Reminder">
                {getFieldDecorator("reminder", {
                  rules: [{ required: true, message: "Choose one!" }],
                  initialValue: 1,
                })(
                  <RadioGroup>
                    <RadioButton value={1}>Yes</RadioButton>
                    <RadioButton value={0}>No</RadioButton>
                  </RadioGroup>
                )}
              </FormItem>
            </Col>

            <Col span={12}>
              <FormItem {...thirdformItemLayout} label="Doctor">
                {getFieldDecorator("doctor_id", {
                  rules: [{ required: false, message: "Choose one!" }],
                })(
                  <Select
                    showSearch
                    value={docSearchValue}
                    placeholder="Start typing Doctor name ..."
                    style={{ width: "80%" }}
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    onSearch={this.handleDocSearch}
                    onChange={this.handleDocChange}
                    onSelect={this.handleDocSelect}
                    notFoundContent={docFetching ? <Spin size="small" /> : null}
                  >
                    {docOptions}
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>

          <br />
          <br />

          <Button
            style={{ marginLeft: "-15%" }}
            type="primary"
            loading={submitLoading}
            htmlType="submit"
          >
            Submit
          </Button>
          <DoneStatusModal
            visible={doneStatusModal}
            onAllOrder={this.goToAllOrders}
            onEPrescription={this.goToEPrescription}
          />
        </Form>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

const mapStateToProps = (state) => ({
  order_id: state.AppState.order_id,
  medicineList: state.AppState.medicineList,
});
const mapDispatchToProps = (dispatch) => ({
  setOrderValuesInStore: (data) =>
    dispatch({ type: ADD_PATIENT_DETAILS, data }),
  changeMenu: (key) => dispatch({ type: MENU_CHANGE, key }),
  setEPrescriptionMedicine: (list, ep_id) =>
    dispatch({ type: EDIT_EPRESCRIPTION, payload: { list, ep_id } }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedNormalLoginForm);



// WEBPACK FOOTER //
// ./src/component/AddOrder/AddOrderForm.js